import React, { useEffect } from 'react'
import Header2 from '../Header/Header2'
import banner from '../../assests/images/detail_game.png'
import gimg from '../../assests/images/air_fighter.png'
import activestar from '../../assests/images/star_active.svg'
import inactivestar from '../../assests/images/start_inactive.svg'
import diamond from '../../assests/images/diamond.svg'
import play from '../../assests/images/PLay_btn.svg'
import playicon from '../../assests/images/play_icon.svg'
import Loader from '../../assests/images/loader.gif'
import complete from '../../assests/images/completed.svg'
import Footer from '../footer/Footer'
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useContext } from 'react';
import { DataContext } from '../../context/DataContext';
import { Gamedetails } from "../../utils/Api";
import { Link, useParams } from 'react-router-dom'
const Details = () => {
  const { Cid } = useParams()
  // const Cid = 101;
  const { data, loading, error, refetch } = useContext(DataContext);

  const { data: Gamesdata, isLoading: isUserLoading, isError: userError } = useQuery({
    queryKey: ["GamesDetails", data ? data.user_id : '', data ? data.idtoken : '', Cid],
    queryFn: async () => await Gamedetails({
      user_id: data ? data.user_id : '',
      // idtoken: data ? data.idtoken : '',
      contest_id: Cid,
    }),
  });


  if (isUserLoading || loading) return <div className="body_area22">
    <div className="cointainr loader">
      <img src={Loader}></img>
    </div></div>;

  if (userError) return <p>Error: {userError.message}</p>;

  return (
    <>
      <Header2 diamond={Gamesdata?.diamond_balance}></Header2>
      <div className="body_area22">
        <div className="cointainr">
          {/* Game Banner*/}
          <div className="top_info">
            <img
              src={Gamesdata?.result?.game_details?.image_url}
              alt="game"
              className="detail_banner"
            />
            <div className="img_blr" />
          </div>
          <div className="column_area">
            <div className="game_info_d">
              <img src={Gamesdata?.result?.game_details?.icon_image_white} alt="icon" className="icon_sq100" />
              <div className="game_info_nm">
                <h2 className="ttl_bg ttl_bg2">{Gamesdata?.result?.game_details?.contest_name}</h2>
                <div className="star_rating">
                  {Array.from({ length: 5 }).map((_, index) => {
                    return index < Gamesdata?.result?.game_details?.total_reviews
                      ? <img key={index} src={activestar} alt="star" />
                      : <img key={index} src={inactivestar} alt="star" />
                  })}
                  {/* <img src={activestar} alt="star" />
                  <img src={activestar} alt="star" />
                  <img src={activestar} alt="star" />
                  <img src={inactivestar} alt="star" />
                  <img src={inactivestar} alt="star" /> */}
                  <p>{Gamesdata?.result?.game_details?.total_reviews} Reviews</p>
                </div>
                <div className="win_daim btn_tp">
                  <img src={diamond} alt="diamond" />
                  {Gamesdata?.result?.game_details?.total_prize}
                </div>
              </div>
            </div>
            <div className="game_more_inf">
              <div className="categ">
                <p>{Gamesdata?.result?.game_details?.category_name}</p>
              </div>
              <div className="status_com">
                <p>
                  Status: <span className="complte_stats">{Gamesdata?.result?.game_details?.complete_status}%</span>Completed
                </p>
              </div>
            </div>
            <p className="desc">
              {Gamesdata?.result?.game_details?.games_discription}
            </p>
            {/*Play Button*/}
            <a href={`${Gamesdata?.result?.game_details?.game_url}/index.html?user_id=${data?.user_id}&contest_id=${Cid}`} className="play_now">
              <img src={play} alt="play" />
              Play to Earn
            </a>
            <hr />
            <div className="d_flx2">
              <h2 className="main_ttl">
                Tasks to<p>Complete</p>
              </h2>
            </div>
            <div className="Tasks_rem">

              {
                Gamesdata?.result?.game_details?.game_tasks?.map((ele, idx) => {
                  if (ele.status == 'completed') {
                    return (
                      <div className="taks_item">
                        <div className="d_flex roww">
                          <h1 className="task_count">{idx + 1}</h1>
                          <div className="d_flex">
                            <h2 className="ttl_sm">{ele.task_title}</h2>
                            <div className="win_daim btn_tp">
                              <img src={diamond} alt="diamond" />
                              {ele.task_prize}
                            </div>
                          </div>
                        </div>
                        <img src={complete} alt="play" />
                      </div>
                    )
                  } else if (ele.status == 'playable') {
                    return (
                      <div className="taks_item current_task">
                        <div className="d_flex roww">
                          <h1 className="task_count">{idx + 1}</h1>
                          <div className="d_flex">
                            <h2 className="ttl_sm">{ele.task_title}</h2>
                            <div className="win_daim btn_tp">
                              <img src={diamond} alt="diamond" />
                              {ele.task_prize}
                            </div>
                          </div>
                        </div>
                        <a href={`${Gamesdata?.result?.game_details?.game_url}/index.html?user_id=${data?.user_id}&contest_id=${Cid}`}>
                          <img src={playicon} alt="play" className="pulse2" />
                        </a>
                      </div>
                    )
                  } else {
                    return (
                      <div className="taks_item">
                        <div className="d_flex roww">
                          <h1 className="task_count">{idx + 1}</h1>
                          <div className="d_flex">
                            <h2 className="ttl_sm">{ele.task_title}</h2>
                            <div className="win_daim btn_tp">
                              <img src={diamond} alt="diamond" />
                              {ele.task_prize}
                            </div>
                          </div>
                        </div>
                        <img src={playicon} alt="play" className="not_played" />
                      </div>
                    )
                  }
                })
              }

              {/* <div className="taks_item">
                <div className="d_flex roww">
                  <h1 className="task_count">1</h1>
                  <div className="d_flex">
                    <h2 className="ttl_sm">Play The Game!</h2>
                    <div className="win_daim btn_tp">
                      <img src={diamond} alt="diamond" />
                      200
                    </div>
                  </div>
                </div>
                <img src={complete} alt="play" />
              </div>
              <div className="taks_item current_task">
                <div className="d_flex roww">
                  <h1 className="task_count">2</h1>
                  <div className="d_flex">
                    <h2 className="ttl_sm">Play The Game!</h2>
                    <div className="win_daim btn_tp">
                      <img src={diamond} alt="diamond" />
                      200
                    </div>
                  </div>
                </div>
                <img src={playicon} alt="play" className="pulse2" />
              </div>
              <div className="taks_item">
                <div className="d_flex roww">
                  <h1 className="task_count">3</h1>
                  <div className="d_flex">
                    <h2 className="ttl_sm">Play The Game!</h2>
                    <div className="win_daim btn_tp">
                      <img src={diamond} alt="diamond" />
                      200
                    </div>
                  </div>
                </div>
                <img src={playicon} alt="play" className="not_played" />
              </div>
              <div className="taks_item">
                <div className="d_flex roww">
                  <h1 className="task_count">4</h1>
                  <div className="d_flex">
                    <h2 className="ttl_sm">Play The Game!</h2>
                    <div className="win_daim btn_tp">
                      <img src={diamond} alt="diamond" />
                      200
                    </div>
                  </div>
                </div>
                <img src={playicon} alt="play" className="not_played" />
              </div>
              <div className="taks_item">
                <div className="d_flex roww">
                  <h1 className="task_count">5</h1>
                  <div className="d_flex">
                    <h2 className="ttl_sm">Play The Game!</h2>
                    <div className="win_daim btn_tp">
                      <img src={diamond} alt="diamond" />
                      200
                    </div>
                  </div>
                </div>
                <img src={playicon} alt="play" className="not_played" />
              </div> */}
            </div>
            <div className="d_flx2">
              <h2 className="main_ttl">
                Steps to<p>Complete</p>
              </h2>
            </div>
            <ul className="steps_compl">
              {
                Gamesdata?.result?.game_details?.game_tasks?.map((ele, idx) => {
                  return (
                    <li>• Task {idx + 1} - {ele.task_title}.</li>
                  )
                })
              }
              {/* <li>• Task 1 - Play the game.</li>
              <li>• Task 2 - Reach 100 Meters in the game.</li>
              <li>• Task 3 - Reach 500 Meters in the game.</li>
              <li>• Task 4 - Reach 1000 Meters in the game.</li>
              <li>• Task 5 - Reach 5000 Meters in the game.</li> */}
            </ul>
          </div>
          <Footer></Footer>
        </div>
      </div>

    </>
  )
}

export default Details
